// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/ledger/modules/ledger-list/components/no-data-found/no-data-found.less
// module id = 3715
// module chunks = 0